// extracted by mini-css-extract-plugin
module.exports = {"contents-heading":"styles_contents-heading__3-RMg","browser-ie":"styles_browser-ie__1h9Iv"};